<template>
  <el-container>
    <el-header>
      <h3 class="nesc_title40">{{ $t('lang.cellProductionLine') }}</h3>
    </el-header>

    <!-- 电芯产线 -->
    <el-main>
      <div class="nesc_cont1360 nesc_about_content clearfix">
        <el-row type="flex" class="row-bg" style="flex-wrap: wrap;" justify="space-around">
          <el-col v-for="(item, index) in 12" :key="index" class="padding-sm" :span="8" :xs="12">
            <div class="block">
              <el-image
                :style="{opacity: $route.params.type == 'cellProductionLine' ? 1 : 0}"
                style="transition:all 1.0s ease-in-out;box-shadow: 0 5px 10px 0px rgba(214,211,211,0.7)"
                :src="require('../../assets/image/cell/'+item+'.jpg')"
                lazy
              />
            </div>
          </el-col>
        </el-row>
      </div>
    </el-main>
  </el-container>
</template>

<script>
export default {
  name: 'CellProductionLine',
  data: () => {
    return {
      opacity: 0
    }
  },

  mounted() {
    setTimeout(() => {
      this.opacity = 1
    }, 100)
  },
  methods: {}

}
</script>

<style scoped lang="scss">
.el-header {
  height: auto !important;
}
.el-main {
  margin-bottom: 100px;
}

.nesc_about_content {
  position: relative;
  z-index: 1;
  overflow: hidden;
  margin: 0 auto;
}

</style>
